(function () {
  var KEY = 'ks_cookie_consent_v1';

  function hide(root) {
    root.setAttribute('hidden', '');
    root.setAttribute('aria-hidden', 'true');
  }

  function setShopifyConsent(accepted) {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: accepted,
            marketing: accepted,
            preferences: accepted,
            sale_of_data: accepted,
          },
          function () {}
        );
      }
    } catch (e) {}
  }

  function bind(root) {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';
    try {
      if (window.localStorage.getItem(KEY)) {
        hide(root);
        return;
      }
    } catch (e) {}

    root.querySelectorAll('[data-ks-consent]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var accepted = btn.getAttribute('data-ks-consent') === 'accept';
        try {
          window.localStorage.setItem(KEY, accepted ? 'accepted' : 'essential');
        } catch (e) {}
        setShopifyConsent(accepted);
        hide(root);
      });
    });
  }

  document.querySelectorAll('kingdom-cookie-banner').forEach(bind);
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('kingdom-cookie-banner').forEach(bind);
  });
})();
